// Historia 148 — la búsqueda del modal. Módulo HOJA, sin imports.
//
// D10 fija la semántica y la cierra: **nombre del documento**, coincidencia por **subcadena**,
// insensible a mayúsculas **y a acentos** (en planta se escribe sin tildes). NO busca en la
// descripción, ni en el tipo, ni en el nombre de fichero — ampliar el alcance contradice el GATE 1.
//
// Es la ÚNICA reducción que Jupiter hace sobre lo recibido (D1): opera sobre los grupos que ya
// llegaron y nunca consulta al servidor, así que jamás puede revelar un documento de un grupo que
// el perfil no tiene permiso de ver (S66) — ese grupo sencillamente no está en los datos.

/** Minúsculas y sin diacríticos: «Certificación» y «certificacion» son la misma búsqueda. */
const normalizeForSearch = (text) => String(text === undefined || text === null ? '' : text)
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase()

/**
 * Reduce los grupos recibidos a los documentos cuyo NOMBRE contiene el texto buscado. Un grupo que
 * se queda sin coincidencias desaparece entero (RN12/S64): nunca una cabecera vacía ni un contador
 * a cero.
 * @param {Array} groups Los grupos tal y como llegaron del endpoint agregador
 * @param {string} searchText Texto libre; vacío = sin filtro (V8)
 * @returns {Array} Los mismos grupos, con las entradas que casan
 */
const filterGroupsByDocumentName = (groups = [], searchText = '') => {
  const needle = normalizeForSearch(searchText).trim()
  if (needle === '') {
    return groups
  }
  return groups
    .map((group) => ({
      ...group,
      entries: group.entries.filter(
        (entry) => normalizeForSearch(entry?.document?.documentName).includes(needle)
      )
    }))
    .filter((group) => group.entries.length > 0)
}

export { normalizeForSearch, filterGroupsByDocumentName }
